module.exports = __webpack_public_path__ + "static/media/icon_reservation.4f294504.svg";